import api from "@/api/index";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },

  addPush({ commit }, payload) {
    commit("ADD_PUSH", payload);
  },

  updateStatusPushs({ commit }) {
    commit("UPDATE_STATUS_PUSHS");
  },
  updateStatusPush({ commit }, payload) {
    commit("UPDATE_STATUS_PUSH", payload);
  },

  getNotifications({ commit }, payload) {
    api.notifications
      .getNotifications(payload)
      .then(response => {
        if (payload.page > 1) {
          commit("ADD_NOTIFICATIONS", response.data.results);
        } else {
          commit("SET_NOTIFICATIONS", response.data.results);
        }
        commit("COUNT_NOTIFICATIONS", response.data.count);
      })
      .catch(error => {
        console.log(error);
      });
  }
};

export default actions;
